import { AutoCorrectPropertyEvent } from './AutoCorrectModelEvents.js';
export class AutoCorrectModelPublisher {
    constructor(notifications) {
        this.notifications = notifications;
    }
    propertyAutoCorrected(target, propertyPath, fromValue, toValue) {
        this.notifications.notify('AutoCorrectProperty', new AutoCorrectPropertyEvent(target, propertyPath, fromValue, toValue));
    }
}
//# sourceMappingURL=AutoCorrectModelPublisher.js.map